export const Traces = {
	variable: '$condition: TraceQueryCondition',
	query: `
  data: queryBasicTraces(condition: $condition) {
    traces {
      key: segmentId
      endpointNames
      duration
      start
      isError
      traceIds
    }
    total
  }`,
};

export const ServiceInstanceOption = {
	variable: '$duration: Duration!, $serviceId: ID!',
	query: `
    instanceId: getServiceInstances(duration: $duration, serviceId: $serviceId) {
      key: id
      label: name
    }`,
};

/**
 * @param { traceId } { string }
 */
export const Trace = {
	variable: '$traceId: ID!, $duration: Duration, $correlatedCapability: String',
	query: `
  trace: queryTrace(traceId: $traceId, duration: $duration, correlatedCapability: $correlatedCapability) {
    spans {
      traceId
      segmentId
      spanId
      parentSpanId
      refs {
        traceId
        parentSegmentId
        parentSpanId
        startTime
        type
      }
      serviceCode
      noOfChild
      startTime
      endTime
      endpointName
      methodName
      type
      peer
      component
      isError
      layer
      tags {
        key
        value
      }
      logs {
        time
        data {
          key
          value
        }
      }
    }
    isCorrelationAvailable
    correlatedInstanceId
    toShowMethod
  }
  `,
};

export const LogTraces = {
	variable: '$condition: TraceQueryCondition',
	query: `
  data: queryBasicTraces(condition: $condition) {
    traces {
      key: segmentId
      serviceId
      serviceInstanceId
      endpointNames
      duration
      start
      isError
      traceIds
    }
    total
  }`
};

export const TraceDetailExist = {
  variable: '$condition: TracesQueryCondition!',
  query: `tracesExists: queryBasicTracesMulti(condition: $condition) {
    traceId: traceId
    isPresent: isPresent
    isAccessible
}`,
};
export const TraceInstances = {
  variable: '$keyword: String, $duration: Duration, $serviceId: ID!, $properties: [KeyValuePair],$pagination: Pagination',
  query: `instanceId: getServiceInstancesWithTotalCount(keyword: $keyword, duration: $duration, serviceId: $serviceId, properties: $properties,pagination: $pagination) {   
    serviceInstances {
        key: id
        label: name
        attributes {
            name
            value
        }
      }  
  total
  }`
}

export const TraceEndpoints = {
  variable: '$keyword: String, $serviceId: ID!, $duration: Duration!, $pagination: Pagination',
  query: `getEndpoints: searchRangeEndpointWithTotalCount(keyword: $keyword, serviceId: $serviceId, duration: $duration,pagination: $pagination) {
    endpoints {
      key: id
      label: name
    }
   total
  }`
}

